<template>
  <card :title="title" v-loading="loading">
    <Table
      :items="playgrounds"
      :columns="columns"
      :links="links"
      :actions="actions"
      filterProp="name"
    />
  </card>
</template>

<script>
import Card from '@/components/Card';
import Table from '@/components/Table';
import { generationSessionType, isZipGenerationSession } from '@/utils/generationSessions';

export default {
  props: {
    playgrounds: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Playgrounds',
    },
  },
  data() {
    return {
      columns: [
        { label: 'ID', prop: 'id' },
        { label: 'Name', prop: 'name' },
        { label: 'Type', formatter: generationSessionType },
        { label: 'Created at', formatter: item => item.created_at ? new Date(item.created_at).toLocaleDateString() : '-' },
      ],
      links: [
        {
          label: 'View playground',
          to: item => `/customers/playground/${item.id}`,
          visible: item => !isZipGenerationSession(item),
        },
        {
          label: 'Open ZIP',
          href: item => item.target_url,
          visible: item => isZipGenerationSession(item) && Boolean(item.target_url),
        },
      ],
      actions: [
        {
          name: 'Unpublish',
          type: 'warning',
          requiresConfirm: true,
          title: 'Stop serving the published site. Assets stay in S3 and the playground keeps its current privacy.',
          visible: item => !isZipGenerationSession(item) && Boolean(item.live_url),
          onClick: item => this.unpublishPlayground(item),
        },
        {
          name: 'Takedown',
          type: 'danger',
          requiresConfirm: true,
          title: 'Zip dist assets, wipe them from S3, clear CloudFront cache, mark the playground private. Recovery zip posted to #abuse.',
          visible: item => !isZipGenerationSession(item),
          onClick: item => this.takedownPlayground(item),
        },
      ],
    };
  },
  components: {
    Card,
    Table,
  },
  methods: {
    async unpublishPlayground(item) {
      try {
        const { data } = await this.$api.post(`/cs/playgrounds/${item.id}/unpublish`);
        this.$message.success(data.message || 'Unpublish queued');
        this.$emit('refresh');
      } catch (e) {
        console.error(e);
        this.$message.error('Failed to unpublish playground');
      }
    },
    async takedownPlayground(item) {
      try {
        const { data } = await this.$api.post(`/cs/playgrounds/${item.id}/takedown`);
        this.$message.success(data.message || 'Takedown queued');
        this.$emit('refresh');
      } catch (e) {
        console.error(e);
        this.$message.error('Failed to takedown playground');
      }
    },
  },
};
</script>

<style scoped>
</style>
